module.exports = __webpack_public_path__ + "static/media/bucky.381fdf2e.png";